module.exports = __webpack_public_path__ + "static/media/twitter.bb8ae360.svg";